import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "area_title" }
const _hoisted_3 = { class: "area_button" }
const _hoisted_4 = { class: "area_body" }
const _hoisted_5 = { class: "area_section" }
const _hoisted_6 = { class: "area_table" }
const _hoisted_7 = { class: "area_table_body" }
const _hoisted_8 = {
  key: 0,
  class: "container"
}
const _hoisted_9 = { class: "area_title" }
const _hoisted_10 = { class: "area_button" }
const _hoisted_11 = { class: "area_body" }
const _hoisted_12 = { class: "area_section" }
const _hoisted_13 = { class: "area_table" }
const _hoisted_14 = { class: "area_table_body" }
const _hoisted_15 = {
  key: 1,
  class: "container",
  style: {"display":"flex"}
}
const _hoisted_16 = { style: {"width":"50%","margin-right":"10px"} }
const _hoisted_17 = { class: "area_title" }
const _hoisted_18 = { class: "area_button" }
const _hoisted_19 = { class: "area_body" }
const _hoisted_20 = { class: "area_section" }
const _hoisted_21 = { class: "area_table" }
const _hoisted_22 = { class: "area_table_body" }
const _hoisted_23 = { style: {"width":"50%","margin-left":"10px"} }
const _hoisted_24 = { class: "area_title" }
const _hoisted_25 = { class: "area_button" }
const _hoisted_26 = { class: "area_body" }
const _hoisted_27 = { class: "area_section" }
const _hoisted_28 = { class: "area_table" }
const _hoisted_29 = { class: "area_table_body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Left = _resolveComponent("Left")!
  const _component_DataGrid = _resolveComponent("DataGrid")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createVNode(_component_Left),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _cache[5] || (_cache[5] = _createElementVNode("p", null, "내담자 검색", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.router.push({ name: 'client' }))),
              class: "type1"
            }, _cache[4] || (_cache[4] = [
              _createElementVNode("span", null, "전체보기", -1)
            ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_DataGrid, {
                  list: $setup.clientPageState.list,
                  columns: $setup.clientPageState.fields,
                  totalLength: $setup.clientPageState.length,
                  perPage: $setup.clientPageState.perPage,
                  isLoading: $setup.clientPageState.isLoading,
                  onOnRowClick: $setup.fnRowClick
                }, null, 8, ["list", "columns", "totalLength", "perPage", "isLoading", "onOnRowClick"])
              ])
            ])
          ])
        ])
      ])
    ]),
    ($setup.user.userInfo.auth > 5)
      ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_9, [
              _cache[7] || (_cache[7] = _createElementVNode("p", null, "상담 기록 검색", -1)),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.router.push({ name: 'counsel' }))),
                  class: "type1"
                }, _cache[6] || (_cache[6] = [
                  _createElementVNode("span", null, "전체보기", -1)
                ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_DataGrid, {
                      list: $setup.counselPageState.list,
                      columns: $setup.counselPageState.fields,
                      totalLength: $setup.counselPageState.length,
                      perPage: $setup.counselPageState.perPage,
                      isLoading: $setup.counselPageState.isLoading,
                      onOnRowClick: $setup.fnRowClick2
                    }, null, 8, ["list", "columns", "totalLength", "perPage", "isLoading", "onOnRowClick"])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("section", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _cache[9] || (_cache[9] = _createElementVNode("p", null, "잔여량이 가장 많은 물품", -1)),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.router.push({ name: 'item' }))),
                  class: "type1"
                }, _cache[8] || (_cache[8] = [
                  _createElementVNode("span", null, "전체보기", -1)
                ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_DataGrid, {
                      list: $setup.itemPageState1.list,
                      columns: $setup.itemPageState1.fields,
                      totalLength: $setup.itemPageState1.length,
                      perPage: $setup.itemPageState1.perPage,
                      isLoading: $setup.itemPageState1.isLoading,
                      onOnRowClick: $setup.fnRowClick3
                    }, null, 8, ["list", "columns", "totalLength", "perPage", "isLoading", "onOnRowClick"])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _cache[11] || (_cache[11] = _createElementVNode("p", null, "가장 최근에 입고된 물품", -1)),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.router.push({ name: 'item' }))),
                  class: "type1"
                }, _cache[10] || (_cache[10] = [
                  _createElementVNode("span", null, "전체보기", -1)
                ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_DataGrid, {
                      list: $setup.itemPageState2.list,
                      columns: $setup.itemPageState2.fields,
                      totalLength: $setup.itemPageState2.length,
                      perPage: $setup.itemPageState2.perPage,
                      isLoading: $setup.itemPageState2.isLoading,
                      onOnRowClick: $setup.fnRowClick4
                    }, null, 8, ["list", "columns", "totalLength", "perPage", "isLoading", "onOnRowClick"])
                  ])
                ])
              ])
            ])
          ])
        ])),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 2,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}